import { pluginApi } from 'services/api';
import { Filters } from './types';

export default async (filters:  Filters) => {
  
  const { data } = await pluginApi.get(
    '/participants/produtor/getProducerData',
    {
      params: filters,
    }
  );
  return data;
};